import { Global, SdsThemeProvider, type Theme } from '@smiledragon-corp/sds-system';
import type { ReactNode } from 'react';
import { globalStyles } from './globalStyle';
import { viewupTheme } from './theme';

export const ViewupThemeProvider2 = ({ children }: { children: ReactNode; customThem?: Theme }) => {
  return (
    <SdsThemeProvider theme={viewupTheme}>
      <Global styles={globalStyles} />
      {children}
    </SdsThemeProvider>
  );
};
